exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-titel[data-v-54665e1f]{box-shadow:0 1px 5px rgb(0 0 0/10%);border-radius:5px}.box-table[data-v-54665e1f]{padding:5px}.thead-color1[data-v-54665e1f]{background-color:rgba(255,205,86,.3)}.thead-color2[data-v-54665e1f]{background-color:rgba(75,192,192,.3)}.thead-color3[data-v-54665e1f]{background-color:rgba(153,102,255,.3)}.box-table table tbody tr td[data-v-54665e1f]{height:22px}.chart-size[data-v-54665e1f]{height:268px}.color-back1[data-v-54665e1f]{background-color:#f7f7f7}.color-back2[data-v-54665e1f]{background-color:#ffecf0}.color-back3[data-v-54665e1f]{background-color:#f5fdff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54665e1f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/Dashboard/Dashboard.vue
// module id = 552
// module chunks = 0